import { combineReducers } from 'redux';

/* -- User access Slices -- */
import userAccessSlice from './userAccessSlice';
import roleInfo from './UserRoleInfo';

/* -- Loader Slices -- */
import LoaderSlice from './LoaderSlice';
import personalDetailLoaderSlice from './myProfile/personalDetailLoaderSlice';
import workflowLoaderSlice from './workflowLoaderSlice';
import salaryLoadersSlice from './myProfile/salaryAggregates/salaryLoadersSlice';

/* -- Dashboard Slices -- */
import weatherSlice from './weatherSlice';
import authSlice from './authSlice';
import employeeCompanySlice from './employeeCompanySlice';

import authTokenSlice from './authTokenSlice';
import authPermissionSlice from './authPermissionSlice';
import myTeamSlice from './myTeamSlice';
import upcomingBirthdaySlice from './upcomingBirthdaySlice';
import upcomingEventsSlice from './upcomingEventsSlice';

import reportsToSlice from './reportsToSlice';
import timelineSlice from './timelineSlice';
import pendingRequestSlice from './pendingRequestSlice';
import clockInSlice from './clockInSlice';
import clockOutSlice from './clockOutSlice';
import dashboardCalendarSlice from './dashboardCalendarSlice';

/* -- Profile Details Slices -- */
import profilePicSlice from './profilePicSlice';
import userAwardsSlice from './userAwardsSlice';

/* -- Profile Details Slices -- */
import aboutMeSlice from './myProfile/aboutMeSlice';
import personalInfoSlice from './myProfile/personalInfoSlice';
import jobInfoSlice from './myProfile/jobInfoSlice';
import emergencyContactSlice from './myProfile/emergencyContactSlice';
import bankInfoSlice from './myProfile/bankInfoSlice';
import getCountriesSlice from './getCountriesSlice';
import updateCardSlice from './myProfile/updateCardSlice';
import skillsSlice from './myProfile/skillsSlice';

/* -- Salary Slices -- */
import allowanceSlice from './myProfile/salaryAggregates/allowanceSlice';
import otherAllowanceSlice from './myProfile/salaryAggregates/otherAllowanceSlice';
import updatedSalaryDateSlice from './myProfile/salaryAggregates/updatedSalaryDateSlice';
import previousAllowanceSlice from './myProfile/salaryAggregates/previousAllowanceSlice';
import previousOtherAllowanceSlice from './myProfile/salaryAggregates/previousOtherAllowanceSlice';

import empGovtTaxSlice from './myProfile/salaryAggregates/empGovtTaxSlice';
import payHistorySlice from './myProfile/salaryAggregates/payHistorySlice';

/* -- Documents Slices -- */

import getActiveEmpDocsSlice from './myProfile/DocumentAggregates/getActiveEmpDocsSlice';
import getExpiredEmpDocsSlice from './myProfile/DocumentAggregates/getExpiredEmpDocsSlice';

/* -- Dependents Slices -- */
import dependentslistSlice from './myProfile/DependentsAggregates/dependentslistSlice';

/* -- Leaves Slices -- */
import leaveAppliedSlice from './myProfile/leavesAggregates/leaveAppliedSlice';
import leaveHistorySlice from './myProfile/leavesAggregates/leaveHistorySlice';
import leaveEligibilitySlice from './myProfile/leavesAggregates/leaveEligibilitySlice';
import leaveCalendarSlice from './myProfile/leavesAggregates/leaveCalendarSlice';

/* -- Attendance Slices -- */
import getEmpWeekoffNTimeshiftSlice from './myProfile/AttendanceAggregates/getEmpWeekoffNTimeshiftSlice';
import getEmpTimeSheetSlice from './myProfile/AttendanceAggregates/getEmpTimeSheetSlice';
/* -- Loans Slices -- */
import activeLoansSlice from './myProfile/loansAggregates/activeLoansSlice';
import loansHistorySlice from './myProfile/loansAggregates/loansHistorySlice';

/* -- Assets Slices -- */
import activeAssetsSlice from './myProfile/AssetsAggregates/activeAssetsSlice';
import returnAssetSlice from './myProfile/AssetsAggregates/returnAssetSlice';

/* -- Shift and Schedule Slices -- */
import allShiftsLists from './myProfile/shiftAndScheduleAggregates/allShiftsLists';

/* -- Claim Slices -- */
import claimListSlice from './myProfile/claimAggregates/claimListSlice';
import claimHistorySlice from './myProfile/claimAggregates/claimHistorySlice';
import airTicketHistorySlice from './myProfile/claimAggregates/airTicketHistorySlice';
import airTicketsSlice from './myProfile/claimAggregates/airTicketsSlice';

/* -- Insurance Slices -- */
import insuranceListSlice from './myProfile/insuranceAggregates/insuranceListSlice';
import expiredInsuranceSlice from './myProfile/insuranceAggregates/expiredInsuranceSlice';

/* -- Off boarding Slices -- */
import offBoardingListSlice from './myProfile/offBoardingAggregates/offBoardingListSlice';
import offBoardingWithdrawnSlice from './myProfile/offBoardingAggregates/offBoardingWithdrawnSlice';

/* -- Annoucement Slices -- */
import announcementSlice from './announcement/announcementSlice';

/* -- SSO - HR View -- */
import isHRViewSlice from './myProfile/isHRViewSlice';

/* -- Notofication View All Trigger -- */
import NotificationSlice from './NotificationSlice';

/* -- Employee Status ACTIVE || IN-ACTIVE -- */
import empStatusSlice from './empStatusSlice';

/* -- sidebarSlice -- */
import sidebarSlice from './sidebarSlice';
import getEmpTrainingSlice from './myProfile/TrainingAggregates/getEmpTrainingSlice';

/* -- Assets Slice -- */
import appliedLetterSlice from './letterGenerator/appliedLetterSlice';
import generatedLetterSlice from './letterGenerator/generatedLetterSlice';

/* -- Action Required - To show the required Selected Action Required-- */
import actionRequiredSlice from './actionRequired/actionRequiredSlice';

/* -- canceheckin attendance setting--- */
import attendancesettingSlice from './myProfile/attendancesettingSlice';

/* -- Performance Data--- */
import PerformanceSlice from './myProfile/Performance/Performance';

/* -- Evaluation Data--- */
import evaluatorDetails from './myProfile/EvaluatorData/evaluatorData';
import viewAsSuperAdminSlice from './viewAsSuperAdminSlice';

import adminIdSlice from './adminIdSlice';
import exception from './Exception';
import sideMenuSlice from './sideMenuSlice';

const appReducer = combineReducers({
  /* -- User access Slices -- */
  userAccessSlice,
  roleInfo,
  // Loaders
  LoaderSlice,
  personalDetailLoaderSlice,
  workflowLoaderSlice,
  salaryLoadersSlice,

  getEmpTrainingSlice,
  profilePicSlice,
  userAwardsSlice,
  weatherSlice,
  authSlice,
  employeeCompanySlice,
  authTokenSlice,
  authPermissionSlice,
  myTeamSlice,
  upcomingBirthdaySlice,
  upcomingEventsSlice,
  //getUserPicSlice,
  reportsToSlice,
  timelineSlice,
  pendingRequestSlice,
  clockInSlice,
  clockOutSlice,
  dashboardCalendarSlice,
  adminIdSlice,

  /* Employee Profile Slices below: */
  aboutMeSlice,
  personalInfoSlice,
  jobInfoSlice,
  emergencyContactSlice,
  bankInfoSlice,
  getCountriesSlice,
  updateCardSlice,
  skillsSlice,

  /* Employee Salary Slices below: */
  allowanceSlice,
  otherAllowanceSlice,
  updatedSalaryDateSlice,
  previousAllowanceSlice,
  previousOtherAllowanceSlice,
  empGovtTaxSlice,
  payHistorySlice,

  /* Documents Slices below: */
  getActiveEmpDocsSlice,
  getExpiredEmpDocsSlice,

  /* Dependents Slices below: */
  dependentslistSlice,

  /* Attendance Slice below: */
  getEmpWeekoffNTimeshiftSlice,
  getEmpTimeSheetSlice,

  /* Leaves Slices below: */
  leaveAppliedSlice,
  leaveHistorySlice,
  leaveEligibilitySlice,
  leaveCalendarSlice,

  /* Loans Slices below: */
  activeLoansSlice,
  loansHistorySlice,

  /* Claims Slices below: */
  claimListSlice,
  claimHistorySlice,
  airTicketHistorySlice,
  airTicketsSlice,

  // Assets Slice below:
  activeAssetsSlice,
  returnAssetSlice,

  /* Insurance Slices below: */
  insuranceListSlice,
  expiredInsuranceSlice,

  /* Off-boarding Slices below: */
  offBoardingListSlice,
  offBoardingWithdrawnSlice,

  /* Annoucements Slices below: */
  announcementSlice,

  /* SSO - isHRView below: */
  isHRViewSlice,

  /* notification view all triger slice*/
  NotificationSlice,

  /* -- Employee Status ACTIVE || IN-ACTIVE -- */
  empStatusSlice,

  /* -- sidebar slice -- */
  sidebarSlice,

  /* -- allShiftsLists slice -- */
  allShiftsLists,

  /* -- assetss slice -- */

  appliedLetterSlice,
  generatedLetterSlice,

  /* -- Action Required Slice --*/
  actionRequiredSlice,

  /* -- canceheckin attendance setting--- */
  attendancesettingSlice,
  /* -- Performance Employee Detail --- */
  PerformanceSlice,

  /* -- Evaluation Detail --- */
  evaluatorDetails,
  viewAsSuperAdminSlice,

  exception,
  sideMenuSlice,
});
const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
